import React, { useState } from 'react';

function Alert({ children, type,clearError }) {

    const [show, setShow] = useState(true);
    const handleClose = () => {
        setShow(false); // Update the state to hide the alert
        if(clearError){                
            clearError();
        }
        
    };
    
    return (
        <>
            { show &&
                <div className={'alert alert-dismissible '+ type} role="alert">
                    {clearError && <button type="button" className="close" aria-label="Close"
                     onClick={handleClose} 
                    >
                        <span aria-hidden="true">×</span>
                    </button>}
                    
                    <div className="">
                        {children}
                    </div>
                </div>
            }
        </>
  
    );
}

export default Alert;